import DataTable from "../common/DataTable";
import StatusBadge from "../common/StatusBadge";
import ProgressBar from "../common/ProgressBar";
import { itemAchievement, calcWeightedItems } from "../../utils/scoreCalculator";
import { KPI_DIRECTIONS } from "../../utils/constants";
import { formatScore } from "../../utils/format";
import Button from "../common/Button";
import { FiTrendingUp } from "react-icons/fi";

// [NEW] Optional "Update progress" column for the employee. `onUpdate(row)` opens the progress dialog;
// `pending` = ids of items that already have an update waiting for the manager.
const updateColumn = (onUpdate, pending = []) => ({
  key: "update", label: "", align: "right",
  render: (r) => (pending.includes(String(r.id))
    ? <span className="badge badge-info">Awaiting manager approval</span>
    : <Button variant="secondary" size="sm" icon={FiTrendingUp} onClick={() => onUpdate(r)}>Update</Button>),
});

const earned = (weight, achieved) => (achieved === null || achieved === undefined
  ? "—"
  : `${Math.round(((Number(weight) || 0) * achieved) / 100 * 100) / 100}%`);

export function overallPct(rows = [], directionOf) {
  const v = calcWeightedItems(rows, directionOf);
  return v === null || v === undefined ? null : Math.round(v * 100) / 100;
}

const directionLabel = (d) => KPI_DIRECTIONS.find((x) => x.value === d)?.label || "Higher is better";

export function KraTable({ rows = [], emptyText = "No KRAs assigned for this cycle.", onUpdate, pending = [] }) {
  return (
    <DataTable
      rows={rows}
      emptyTitle="No KRAs"
      emptyText={emptyText}
      columns={[
        { key: "name", label: "KRA", render: (r) => (<span className="cell-stack"><strong>{r.name}</strong><small>{r.measurementMethod}</small></span>) },
        { key: "weightage", label: "Goal %", align: "right", render: (r) => <span className="goal-pct-chip">{r.weightage}%</span> },
        { key: "target", label: "Target", align: "right" },
        { key: "actual", label: "Actual", align: "right", render: (r) => r.actual ?? "—" },
        { key: "score", label: "Achieved %", width: 170, render: (r) => <ProgressBar value={itemAchievement(r)} showValue size="sm" /> },
        { key: "earned", label: "Earned %", align: "right", render: (r) => earned(r.weightage, itemAchievement(r)) },
        { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
        ...(onUpdate ? [updateColumn(onUpdate, pending)] : []),
      ]}
    />
  );
}

export function KpiTable({ rows = [], emptyText = "No KPIs assigned for this cycle.", onUpdate, pending = [] }) {
  return (
    <DataTable
      rows={rows}
      emptyTitle="No KPIs"
      emptyText={emptyText}
      columns={[
        { key: "name", label: "KPI", render: (r) => (<span className="cell-stack"><strong>{r.name}</strong><small>{r.frequency}, {directionLabel(r.direction).toLowerCase()}</small></span>) },
        { key: "target", label: "Target", align: "right", render: (r) => `${r.target} ${r.unit === "%" ? "%" : ""}` },
        { key: "actual", label: "Actual", align: "right", render: (r) => (r.actual ?? "—") },
        { key: "score", label: "Achieved %", width: 170, render: (r) => <ProgressBar value={itemAchievement(r, r.direction)} showValue size="sm" /> },
        { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
        ...(onUpdate ? [updateColumn(onUpdate, pending)] : []),
      ]}
    />
  );
}

export function itemScoreText(item, direction) {
  return formatScore(itemAchievement(item, direction));
}

export { directionLabel };
